module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.eot?f43ff11521dd89de1385b0a6aef065ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.eot
// module id = 965
// module chunks = 1